module.exports = __webpack_public_path__ + "static/media/chev-left.2856ff9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/candidate/ScheduleCall/components/BackTo/assets/chev-left.svg
// module id = 1709
// module chunks = 0